import { render, staticRenderFns } from "./CmgMealBuilderItemSelectorCardCustomizationButton.vue?vue&type=template&id=6df0b900&scoped=true&lang=pug"
import script from "./cmg-meal-builder-item-selector-card-customization-button.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-builder-item-selector-card-customization-button.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMealBuilderItemSelectorCardCustomizationButton.vue?vue&type=style&index=0&id=6df0b900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df0b900",
  null
  
)

export default component.exports